import { apiError } from '../apiError';
import axiosInstance from '../axios.config';
import { API_ENDPOINTS } from '../endpoints';
import { ApiResponse } from 'types';

/**
 * Supermemory / context profiles — the cross-channel long-term memory layer an
 * agent references. The runtime reads provider/scope/namespace (injected by the
 * agent's runtime binding) to read/write memory during a conversation.
 */
export interface MemoryProfile {
  id?: number;
  organization_id?: string;
  business_id?: string;
  name: string;
  provider?: 'NONE' | 'SUPERMEMORY';
  scope?: 'BUSINESS' | 'AGENT' | 'CALLER';
  namespace?: string;
  retention_days?: number;
  api_key_ref?: string;
  config?: Record<string, any>;
  enabled?: boolean;
}

// Shared so a 403 reads as a refusal rather than a load failure.
const err = (e: any, msg: string) => apiError(e, msg);

export const memoryProfilesService = {
  list: async (organizationId?: string): Promise<ApiResponse<MemoryProfile[]>> => {
    try { return (await axiosInstance.get(API_ENDPOINTS.MEMORY_PROFILES, { params: organizationId ? { organizationId } : {} })).data; }
    catch (e: any) { return err(e, 'Failed to load memory profiles'); }
  },
  create: async (body: MemoryProfile, organizationId?: string): Promise<ApiResponse<MemoryProfile>> => {
    try { return (await axiosInstance.post(API_ENDPOINTS.MEMORY_PROFILES, body, { params: organizationId ? { organizationId } : {} })).data; }
    catch (e: any) { return err(e, 'Failed to create memory profile'); }
  },
  update: async (id: number, body: MemoryProfile): Promise<ApiResponse<MemoryProfile>> => {
    try { return (await axiosInstance.put(API_ENDPOINTS.MEMORY_PROFILE_DETAIL(id), body)).data; }
    catch (e: any) { return err(e, 'Failed to update memory profile'); }
  },
  remove: async (id: number): Promise<ApiResponse<void>> => {
    try { return (await axiosInstance.delete(API_ENDPOINTS.MEMORY_PROFILE_DETAIL(id))).data; }
    catch (e: any) { return err(e, 'Failed to delete memory profile'); }
  },
};
